<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <i class="material-icons cusIconSize">&#xE8B4;</i>
          <span>Manage Countries</span>
        </p>
      </div>
      <md-card>
        <md-card-header>
          <div class="admPageHeadingSec">
            <md-card-title>
              <div class="admPageHeading">
                <p><span>Search Countries</span></p>
              </div>
            </md-card-title>
            <md-card-content>
              <form class="example-form" [formGroup]="form">
                <div class="col s12 m4 l4">
                  <md-form-field class="example-full-width">
                    <input type="text" placeholder="Country" mdInput formControlName="countryControl" [mdAutocomplete]="country" [showDropDown]="{model: 'country', scope : this }">
                    <md-autocomplete #country="mdAutocomplete" [displayWith]="_utility.displayFn">
                      <md-option *ngFor="let option of countryFilteredOptions | async" [value]="option">
                        {{ option.name }}
                      </md-option>
                    </md-autocomplete>
                  </md-form-field>
                </div>
              </form>
              <div class="col s12 m12 l12">
                <div class="button-row">
                  <button [disabled]="isSearchDisable" md-raised-button class="glbAdminBtnCls1" (click)="onSearchBtnClick()">
                    <i class="material-icons">&#xE8B6;</i>Search</button>
                </div>
              </div>
            </md-card-content>
          </div>
        </md-card-header>
      </md-card>
      <div class="cusPaginationContainer example-container mat-elevation-z8">
        <div *ngIf="paginationInfo && paginationInfo.totalRecords == 0">
          <p class="nodataFound">No Results Found</p>
        </div>
        <md-table class="mngLocGridSec" #table [dataSource]="dataSource" mdSort [ngClass]="{'hide-grid': paginationInfo &&paginationInfo.totalRecords <= 0 }">
          <md-header-row *mdHeaderRowDef="displayedColumns"></md-header-row>
          <md-row *mdRowDef="let row; columns: displayedColumns;"></md-row>
          <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->
          <ng-container mdColumnDef="name">
            <md-header-cell *mdHeaderCellDef md-sort-header>COUNTRY NAME</md-header-cell>
            <md-cell *mdCellDef="let element">{{element.name}}</md-cell>
          </ng-container>
          <ng-container mdColumnDef="code">
            <md-header-cell *mdHeaderCellDef md-sort-header>COUNTRY CODE</md-header-cell>
            <md-cell *mdCellDef="let element">{{element.code}}</md-cell>
          </ng-container>
          <ng-container mdColumnDef="isRequired">
            <md-header-cell *mdHeaderCellDef md-sort-header>PHOTO ID REQUIRED</md-header-cell>
            <md-cell *mdCellDef="let element">{{element.isRequired}}</md-cell>
          </ng-container>
          <ng-container mdColumnDef="unsupportedExamTypes">
            <md-header-cell *mdHeaderCellDef md-sort-header>UNSUPORTED EXAM TYPES</md-header-cell>
            <md-cell *mdCellDef="let element">{{element.unsupportedExamTypes}}</md-cell>
          </ng-container>
          <ng-container mdColumnDef="action">
            <md-header-cell *mdHeaderCellDef>ACTIONS</md-header-cell>
            <md-cell *mdCellDef="let element">
              <a [routerLink]="['/AdmManageCountry', element.id]" (click)="_appGlobal.routeWithID = true">Manage</a>
            </md-cell>
          </ng-container>
        </md-table>
        <md-paginator [ngClass]="{'hide-grid': paginationInfo && paginationInfo.totalRecords <= 0 }" #paginator [length]="paginationInfo.totalRecords"
          [pageIndex]="0" [pageSize]="dataSource.initialPageSize" [pageSizeOptions]="dataSource.pageSizeOptions">
        </md-paginator>
      </div>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-country/adm-manage-country.component.html